import React from 'react'
import { FormControl as MuiFormControl } from '@mui/material'
import { FormControlProps } from './FormControl.types'

const FormControl = (props: FormControlProps) => <MuiFormControl {...props} />

export default FormControl
